import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../utils/axiosInstance"; // Adjust path as needed

const useUpdateAssetData = (
  endpoint: string,
  queryKey: string,
  queryParams?: string,
  enabledParams: (string | undefined | null)[] = [],
  data?: Record<string, any> // Accept data for the PUT request
) => {

  const updateData = async () => {
    const url = queryParams ? `${endpoint}?${queryParams}` : endpoint;
    const response = await axiosInstance.put(url, data); // Pass data in the PUT request
    return response.data;
  };
  return useQuery({
    queryKey: [queryKey],
    queryFn: updateData,
    enabled: !!queryKey && enabledParams.every((param) => !!param),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: Infinity,
  });
};

export default useUpdateAssetData;
